<template>
  <div
    class="buttonMini buttonMini--circle38 drawingHeaderUI__clear"
    :class="{'button--disable': !savable}"
    @click="clearCanvas"
  >
    <img src="@/assets/header/trash.svg" width="16" alt="" />
  </div>
</template>

<script>
import { DrawEvent } from "../../events/DrawEvent";
import * as drawEventType from "../../events/DrawEventType";
export default {
  name: "ClearCanvasUI.vue",
  computed: {
    savable() {
      return this.$store.state.canvas.savable;
    }
  },
  methods: {
    clearCanvas() {
      DrawEvent.emit(drawEventType.CLEAR_CANVAS);
    }
  }
};
</script>
<style scoped lang="sass">
@import "../../sass/colors"
@import "../../sass/common"
.buttonMini
  background-color: $button_bg--dark !important
</style>
